import { TabbedGroup } from "../../../components/TabbedGroup";
import { AdminPermissions as AP } from "../../../lib/data";
import Withdrawals from "../Withdrawals";
import Finance from "../Finance";

export default function Money() {
  return (
    <TabbedGroup
      tabs={[
        { value: "withdrawals", label: "Withdrawals", permission: AP.MANAGE_WITHDRAWALS, element: <Withdrawals /> },
        { value: "float", label: "Float & Liability", permission: AP.MANAGE_WITHDRAWALS, element: <Finance /> },
      ]}
    />
  );
}
